"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordView = exports.changeLanguage = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var queryString = require("query-string");
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var sok_ui_1 = require("@caddigital/sok-ui");
var LoginContainer_1 = require("containers/LoginContainer");
var react_google_recaptcha_1 = require("react-google-recaptcha");
var authActions = require("@caddigital/sok-reducers/lib/actions/auth/forgotPassword");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var translate_1 = require("utils/translate");
var classNames = require("classnames");
var Types = require("types");
var languages_1 = require("utils/helpers/languages");
var LanguageSelectorDropdown_1 = require("components/LanguageSelectorDropdown");
var Icon_1 = require("components/Icon");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var language = languages_1.languageData.find(function (x) { return selectedLanguage === x.code; });
    return {
        translations: state.translations,
        forgotPassword: state.auth.forgotPassword,
        lang: selectedLanguage,
        language: language
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    setRecaptchaCode: function (code) {
        dispatch(authActions.setRecaptchaCodeAction(code));
    },
    setEmail: function (email) {
        dispatch(authActions.setForgotPasswordEmailAction(email.trim().toLowerCase()));
    },
    onRequestNewPassword: function (email, code, language) {
        dispatch(authActions.sendForgotPasswordEmailRequestAction(email.trim().toLowerCase(), code, language));
    },
    onResetPasswordState: function () {
        dispatch(authActions.resetForgotPasswordStateAction());
    },
    redirectToLogin: function (language) { return function () {
        return dispatch((0, connected_react_router_1.replace)("/".concat(language)));
    }; },
    fetchLanguage: function (language) {
        (0, translate_1.setLanguage)(language);
        dispatch((0, translations_1.fetchLanguageRequest)(language));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps);
var bgNumber = Math.floor(Math.random() * (4 - 1)) + 1;
var changeLanguage = function (language, props) {
    props.history.push("/".concat(language, "/forgotpassword"));
    props.fetchLanguage(language);
};
exports.changeLanguage = changeLanguage;
exports.ForgotPasswordView = enhance(/** @class */ (function (_super) {
    __extends(ForgotPasswordViewComponent, _super);
    function ForgotPasswordViewComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRequestNewPassword = function (recaptchaInstance) { return function () {
            _this.props.onRequestNewPassword(_this.props.forgotPassword.email, _this.props.forgotPassword.recaptchaCode, _this.props.lang);
            recaptchaInstance.reset();
        }; };
        return _this;
    }
    ForgotPasswordViewComponent.prototype.componentDidMount = function () {
        var params = queryString.parse(this.props.location.search);
        if (params.email) {
            this.props.setEmail(decodeURIComponent(params.email));
        }
    };
    ForgotPasswordViewComponent.prototype.componentWillUnmount = function () {
        this.props.onResetPasswordState();
    };
    ForgotPasswordViewComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement(LoginContainer_1.LoginContainer, { bg: bgNumber, translations: this.props.translations.translations, changeLanguage: function (lang) { return (0, exports.changeLanguage)(lang, props); } },
            React.createElement("div", { className: 'forgot-password-form' },
                props.forgotPassword.status === 'SENDED' && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'status-message' }, (0, translation_1.getLocalization)('userfront/ForgotPassword/Placeholder/StatusMessage')),
                    React.createElement(sok_ui_1.Button, { size: "large", color: "blue", block: true, text: (0, translation_1.getLocalization)('userfront/ForgotPassword/Placeholder/BackToLoginPageButton'), onClick: props.redirectToLogin(props.lang) }))),
                props.forgotPassword.status === 'SENDING' && (React.createElement("div", { className: 'sending' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                (props.forgotPassword.status === 'STANDBY' ||
                    props.forgotPassword.status === 'FAILED') && (React.createElement(React.Fragment, null,
                    React.createElement(LanguageSelectorDropdown_1.default, { languageCode: props.lang, updateUserLanguage: props.fetchLanguage }),
                    React.createElement(sok_ui_1.TextInput, { id: "email", autoFocus: true, placeholder: (0, translation_1.getLocalization)('userfront/ForgotPassword/Placeholder/EmailAddress'), value: props.forgotPassword.email, onChange: function (e) {
                            return props.setEmail(e.target.value);
                        }, icon: React.createElement(Icon_1.Icon, { className: "fa-envelope" }) }),
                    React.createElement(react_google_recaptcha_1.default, { ref: function (e) { return (_this.recaptchaInstance = e); }, sitekey: __RECAPTCHA_SITEKEY__, onChange: props.setRecaptchaCode, className: 'captcha' }),
                    React.createElement(sok_ui_1.Button, { size: "large", color: "blue", block: true, text: (0, translation_1.getLocalization)('userfront/ForgotPassword/Placeholder/RequestAnewPasswordButton'), disabled: !(props.forgotPassword.email &&
                            props.forgotPassword.recaptchaCode), onClick: this.onRequestNewPassword(this.recaptchaInstance) }),
                    React.createElement("div", { className: classNames('status-message', props.forgotPassword.status === 'FAILED' && 'error') },
                        props.forgotPassword.status === 'FAILED' &&
                            props.forgotPassword.validationError === null &&
                            (0, translation_1.getLocalization)('userfront/ForgotPassword/Placeholder/failure'),
                        props.forgotPassword.status === 'FAILED' &&
                            props.forgotPassword.validationError === 'INVALID_EMAIL' &&
                            (0, translation_1.getLocalization)('userfront/ForgotPassword/Placeholder/invalidEmail')))))));
    };
    return ForgotPasswordViewComponent;
}(React.PureComponent)));
exports.default = exports.ForgotPasswordView;
